import cn from "classnames";
import { type PropsWithChildren, type ReactNode } from "react";
import Layout from "@/components/common/Layout";
import {
  SiteBuilderModuleHeaderAlignment,
  SiteBuilderModuleHeaderPosition,
} from "@/constants/site-builder";
import type { BaseSiteBuilderModule } from "@/types/site-builder";
import s from "./HorizontalHeader.module.scss";

export interface HorizontalHeaderProps {
  module: BaseSiteBuilderModule;
  headerContent: ReactNode;
  fluid: boolean;
  stretchColumns?: boolean;
  collapseTabletMobileGap?: boolean;
}

export default function HorizontalHeader(
  props: PropsWithChildren<HorizontalHeaderProps>,
) {
  const {
    module,
    headerContent,
    fluid,
    stretchColumns,
    collapseTabletMobileGap,
    children,
  } = props;
  const {
    style: {
      display: { headerPosition, headerAlignment, moduleLayout },
    },
  } = module;

  const headerRowClassName = cn("row", s.headerGap, {
    "flex-middle": headerAlignment === SiteBuilderModuleHeaderAlignment.Middle,
    "flex-stretch": stretchColumns,
    [s.collapseHeaderGap]: collapseTabletMobileGap,
  });
  const [moduleLeftColumn, moduleRightColumn] = moduleLayout.split(":");
  const headerRight = headerPosition === SiteBuilderModuleHeaderPosition.Right;

  return (
    <Layout fluid={fluid} containerOnly>
      <div className={headerRowClassName}>
        <div className={`col-12 col-lg-${moduleLeftColumn}`}>
          {headerRight ? children : headerContent}
        </div>
        <div className={`col-12 col-lg-${moduleRightColumn}`}>
          {headerRight ? headerContent : children}
        </div>
      </div>
    </Layout>
  );
}
